import { useEffect, useState } from "react";
import ForgotPasswordForm from "./ForgotPasswordForm";
import ResetPassword from "../ResetPassword";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");

  const onSuccessSendMail = (forgotEmailId: string) => {
    setEmail(forgotEmailId);
  };

  useEffect(() => {
    return () => {
      setEmail("");
    };
  }, []);

  return <>{!email ? <ForgotPasswordForm onSuccessSendMail={(emailId: string) => onSuccessSendMail(emailId)} /> : <ResetPassword emailAddress={email} />}</>;
};

export default ForgotPassword;
